import type { RouteLocationNormalized, RouteLocationNormalizedLoaded } from 'vue-router'
import { createRouter, createWebHistory } from 'vue-router'

import DeviceView from '../views/DeviceView.vue'
import ErrorView from '../views/ErrorView.vue'
import HomeView from '../views/HomeView.vue'
import SideBar from '../components/sidebar/SideBar.vue'
import { useUiStore } from '@/stores/ui.ts'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home_view',
      components: {
        sidebar: SideBar,
        main: HomeView
      },
      children: [
        {
          path: 'devices',
          name: 'home_devices',
          component: () => import('@/components/devices-tab/DevicesTab.vue')
        },
        {
          path: 'changes',
          name: 'home_changes',
          component: () => import('@/components/changes-tab/ChangesTab.vue')
        },
        {
          path: 'verify',
          name: 'home_verify',
          component: () => import('@/components/verify-tab/VerifyTab.vue')
        },
        {
          path: 'flash/:tool(adb|fastboot|odin|amlogic)?',
          name: 'home_flash_tools',
          component: () => import('@/components/flash-tools-tab/FlashToolsTab.vue')
        }
      ]
    },
    {
      path: '/devices/:model',
      name: 'device_view',
      components: {
        sidebar: SideBar,
        main: DeviceView
      },
      props: {
        sidebar(route) {
          return {
            activeModel: route.params.model
          }
        },
        main: true
      },
      children: [
        {
          path: '',
          name: 'device_index',
          redirect: {
            name: 'device_builds'
          }
        },
        {
          path: 'builds',
          name: 'device_builds',
          component: () => import('@/components/builds-tab/BuildsTab.vue'),
          props: true
        },
        {
          path: 'changes',
          name: 'device_changes',
          component: () => import('@/components/changes-tab/ChangesTab.vue'),
          props: true
        }
      ]
    },
    {
      path: '/:model',
      children: [
        {
          path: '',
          redirect: {
            name: 'device_builds'
          }
        },
        {
          path: 'changes',
          redirect: {
            name: 'device_changes'
          }
        }
      ]
    },
    {
      path: '/error',
      name: 'error',
      props: true,
      components: {
        sidebar: SideBar,
        main: ErrorView
      }
    },
    {
      path: '/:pathMatch(.*)*',
      name: '404',
      props: {
        main: {
          message: '404 Not Found'
        }
      },
      components: {
        sidebar: SideBar,
        main: ErrorView
      }
    }
  ]
})

router.beforeEach(async (to: RouteLocationNormalized, from: RouteLocationNormalizedLoaded) => {
  if (to.name !== 'error') useUiStore().setError(undefined)

  if (to.path === '/') {
    const isMobile = window.matchMedia('(max-width: 1024px)').matches
    if (isMobile) {
      await router.push('/devices')
    } else {
      await router.push('/changes')
    }
  } else if (to.path === '/flash' || to.path === '/flash/') {
    await router.push(to.name === from.name ? from.fullPath : '/flash/fastboot')
  }
})

export default router
